import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import classNames from 'classnames';
import messages from './reportApplicationMessages';
import './ReportApplicationCard.scss';

function ReportApplicationCard(props) {
  const { formatMessage } = props.intl;

  return (
    <div
      className="card card-school report-application-card"
      style={(props.style, { cursor: 'pointer' })}
      onClick={props.onClick}
    >
      <div className="card-body">
        <div className="card-id">ID: {props.idString}</div>
        <div className="fixed-actions">
          <button className="edit-card" onClick={props.onEdit}>
            <i className="ti-pencil-alt" />
            {formatMessage(messages.edit)}
          </button>
        </div>
        {/* <i className={classNames('pt-3 cm-icon', props.iconClassName)} /> */}
        <h5 className="card-title my-0 mt-5" style={{ color: '#f59f8d' }}>
          {props.levelSegment.map((l) => (
            <div className="level-segment">{l}</div>
          ))}
          <div className="application-lbl"><FormattedMessage {...messages.application} /></div>
          <div>{props.application}</div>
        </h5>
        <p className="mb-0 mt-3">{props.period}</p>
        <p>{props.abbreviation}</p>
        {props.date && (
          <p>
            {formatMessage(messages.deliver)}: {moment(props.date).format('DD/MM/YYYY')}
          </p>
        )}
        <p className="mb-0">
          {props.students_number}{' '}
          {Number(props.students_number) === 1 ? (
            <FormattedMessage {...messages.studentsSingle} />
          ) : (
            <FormattedMessage {...messages.studentsPlural} />
          )}
        </p>
        <p className="mb-4">
          {props.answered}{' '}
          {Number(props.answered) === 1 ? (
            <FormattedMessage {...messages.replyCardsAttachedSingle} />
          ) : (
            <FormattedMessage {...messages.replyCardsAttachedPlural} />
          )}
        </p>
        <div className="mt-2 mb-4">
          {props.dateStatus.status === '0' ? (
            <span className="btn btn-sm btn-grey" style={{ marginBottom: '10px' }}>
              {formatMessage(messages.questionNoDate)}
            </span>
          ) : (
            <React.Fragment>
              {/* {!props.dateStatus.complete ? (
                <button className="btn btn-sm btn-report btn-report-style" onClick={props.onEdit}>
                  {formatMessage(messages.questionAprovation)}
                </button>
              ) : ( */}
              <button className="btn btn-sm btn-report text-uppercase btn-report-style">
                {formatMessage(messages.seeReports)}
              </button>
              {/* )} */}
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
}

ReportApplicationCard.propTypes = {
  id: PropTypes.string,
  coordinator: PropTypes.bool.isRequired,
  onEdit: PropTypes.func,
  iconClassName: PropTypes.string,
  title: PropTypes.string,
  period: PropTypes.string,
  date: PropTypes.oneOf(PropTypes.string, PropTypes.date),
  amountStudents: PropTypes.number,
  amountCards: PropTypes.number,
  badge: PropTypes.node,
  intl: PropTypes.object,
};

ReportApplicationCard.defaultProps = {
  iconClassName: 'pe-7s-light',
  dateStatus: {},
};

export default injectIntl(ReportApplicationCard);
